
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Card, Grid, Stack, Typography } from '@mui/material';
import MDButton from 'components/MDButton';
import EditIcon from 'common/customIcons/edit';
import { useEffect, useState } from 'react';
import defaultImage from 'assets/images/placeholder-image.png';
import colors from 'assets/theme/base/colors';
import CommonLayout from 'layouts/DashboardLayout';
import StrainTable from './strain';
import { getMainStrain } from '../../redux/slices/strain';
import { useDispatch, useSelector } from 'react-redux';
import { getData } from 'utilities/common';
import { STILO } from 'utilities/constants';
import { getPermissionsByMode } from 'utilities/common';
import { hasSectionPermission } from 'utilities/common';
import NoDataFound from 'common/component/NoDataFound';

export default function Strains() {
  const [currentTab, setCurrentTab] = useState('');
  const dispatch = useDispatch();
  const { mainStrainData = {} } = useSelector(state => state.strain);
  const { search } = useLocation();
  const navigate = useNavigate();
  const { grey } = colors;
  const adminsMode = getData('adminsMode')
  const isStilo = JSON.parse(adminsMode) === STILO
  useEffect(() => {
    if (search) {
      const selectedTab = search?.split('=')?.[1] || '';
      if (selectedTab !== currentTab) {
        navigate(`/strains?orderFilter=${selectedTab}`);
        setCurrentTab(selectedTab);
      }
    }
    else {
      navigate('/strains?orderFilter=main_strains');
      setCurrentTab('');
    }
  }, [search]);

  useEffect(() => {
    dispatch(getMainStrain());
  }, []);

  const uploadThumbnailImage = {
    borderRadius: '20px',
    width: '160px',
    height: '160px',
    objectFit: 'cover',
    boxShadow: '0 0 1px rgb(0 0 0 / 20%)'
  };

  let localUser = getData('login-user-info')
  if (localUser) {
    localUser = JSON.parse(localUser)
  }

  const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
  const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

  const canCreate = hasSectionPermission(permissionsForMode, "Manage Website", "Create");
  const canEdit = hasSectionPermission(permissionsForMode, "Manage Website", "Edit/Update");
  const canView = hasSectionPermission(permissionsForMode, "Manage Website", "View Only");
  const canDelete = hasSectionPermission(permissionsForMode, "Manage Website", "Delete");

  return (
    <>
      <CommonLayout>
        {
          currentTab && currentTab === 'main_strains' ? <Box p={{ xs: 2, sm: 3, lg: 4 }}>
            <Stack direction="row" justifyContent="space-between" spacing={3} mb={3}>
              <Typography variant='h4' fontWeight="semibold" ml={.75}>Strain Homepage</Typography>
              {
                canEdit &&
                <MDButton
                  type='button'
                  variant='outlined'
                  color='dark'
                  size="small"
                  startIcon={<EditIcon width='15px' height='15px' />}
                  onClick={() => navigate('/strains/main-strain')}
                >
                  Edit
                </MDButton>
              }
            </Stack>
            {
              canView &&
              <Card sx={{ p: 3, mb: 4, borderRadius: 2.5, boxShadow: 'none' }}>
                {!isStilo && <><Typography variant='h5' fontWeight="semibold" mb={2}>{isStilo ? "Banner Image" : "Meta Image"}</Typography>
                  <Stack direction="row" flexWrap="wrap" gap={1.25} mb={4}>
                    <img style={uploadThumbnailImage} src={mainStrainData?.image?.url || defaultImage} alt="Strain Name" />
                  </Stack></>}

                <Grid container alignItems="center" spacing={{ xs: 3, md: 5 }} mb={2}>
                  {!isStilo ? <Grid item xs={12}>
                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={0.5}>Title</Typography>
                    <Typography className="quill-text-editor-view" component="div" fontWeight="medium" variant="h6" dangerouslySetInnerHTML={{
                      __html: mainStrainData?.title || '-'
                    }}></Typography>
                  </Grid> : null}

                  <Grid item xs={12}>
                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={0.5}>Meta Title</Typography>
                    <Typography className="quill-text-editor-view" component="div" fontWeight="medium" variant="h6" dangerouslySetInnerHTML={{
                      __html: mainStrainData?.metaTitle || '-'
                    }}></Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={0.5}>Meta Description</Typography>
                    <Typography className="quill-text-editor-view" component="div" fontWeight="medium" variant="h6" dangerouslySetInnerHTML={{
                      __html: mainStrainData?.metaDescription || '-'
                    }}></Typography>
                  </Grid>

                  {isStilo ? <Grid item xs={12}>
                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={0.5}>Heading</Typography>
                    <Typography className="quill-text-editor-view" component="div" fontWeight="medium" variant="h6" dangerouslySetInnerHTML={{
                      __html: mainStrainData?.title || '-'
                    }}></Typography>
                  </Grid> : null}

                  <Grid item xs={12}>
                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>{isStilo ? "Body Text" : "Description"}</Typography>
                    <Typography className="quill-text-editor-view" component="div" fontWeight="medium" variant="h6" dangerouslySetInnerHTML={{
                      __html: mainStrainData?.description || '-'
                    }}></Typography>
                  </Grid>
                  {
                    !isStilo &&   <Grid item xs={12}>
                    {
                      mainStrainData?.faq?.length !== 0 ?
  
                        <Grid container alignItems="center">
                          FAQ
                          {
                            mainStrainData?.faq?.map((data) => {
                              return (
                                <Grid item xs={12} mb={2} key={data.answer}>
                                  <Typography
                                    variant="h5"
                                    fontWeight="medium"
                                    dangerouslySetInnerHTML={{
                                      __html: data?.question || "-",
                                    }}
                                  />
                                  <Typography
                                    variant="body2"
                                    color={grey[600]}
                                    dangerouslySetInnerHTML={{
                                      __html: data?.answer || "-",
                                    }}
                                  />
                                </Grid>
                              )
                            })
                          }
                        </Grid>
                        : <NoDataFound />
                    }
                    </Grid>
                  }
               
                </Grid>
              </Card>
            }
          </Box> : currentTab && currentTab === 'strains' ? <StrainTable canCreate={canCreate} canEdit={canEdit} canView={canView} canDelete={canDelete} /> : null
        }
      </CommonLayout>
    </>
  );
}